// FTEDN Creator — XP Progress Bar
import { useEffect, useState } from 'react';
import './XPBar.css';

interface XPBarProps {
  currentXP: number;
  maxXP: number;
  level: number;
  tierName: string;
  compact?: boolean;
}

export function XPBar({ currentXP, maxXP, level, tierName, compact = false }: XPBarProps) {
  const [animatedWidth, setAnimatedWidth] = useState(0);
  const pct = Math.min((currentXP / maxXP) * 100, 100);

  useEffect(() => {
    const timer = setTimeout(() => setAnimatedWidth(pct), 100);
    return () => clearTimeout(timer);
  }, [pct]);

  if (compact) {
    return (
      <div className="xp-bar-compact">
        <div className="xp-bar-track-compact">
          <div className="xp-bar-fill-compact" style={{ width: `${animatedWidth}%` }} />
        </div>
        <span className="xp-bar-label-compact">Lv.{level}</span>
      </div>
    );
  }

  return (
    <div className="xp-bar-container">
      <div className="xp-bar-header">
        <div className="xp-level-badge">
          <span className="xp-level-num">{level}</span>
        </div>
        <div className="xp-bar-info">
          <span className="xp-tier-name">{tierName}</span>
          <span className="xp-numbers">{currentXP.toLocaleString()} / {maxXP.toLocaleString()} XP</span>
        </div>
      </div>
      <div className="xp-bar-track">
        <div className="xp-bar-fill" style={{ width: `${animatedWidth}%` }}>
          <div className="xp-bar-glow" />
          <div className="xp-bar-shimmer" />
        </div>
      </div>
    </div>
  );
}
